import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment-timezone';

@Component({
  selector: 'hb-datetime-range-picker',
  templateUrl: 'datetime-range-picker.component.html',
})
export class DatetimeRangePickerComponent implements OnInit {
  /**
   * The default start date to show
   */
  @Input() defaultStartDate: Date = moment()
    .tz('America/Mexico_City')
    .subtract(30, 'd')
    .startOf('day')
    .toDate();

  /**
   * The default end date to show
   */
  @Input() defaultEndDate: Date = moment()
    .tz('America/Mexico_City')
    .endOf('day')
    .toDate();

  /**
   * The maximum date to show that can be selected as a start
   */
  @Input() maxStartDate: Date = moment()
    .tz('America/Mexico_City')
    .startOf('day')
    .toDate();

  @Input() minEndDateDate: Date = moment(this.defaultStartDate).toDate();
  @Input() maxEndDateDate: Date = moment().tz('America/Mexico_City').toDate();

  @Output() onDateRangeChanged: EventEmitter<{
    startDate: Date;
    endDate: Date;
  }> = new EventEmitter();

  /**
   * Date Pickers
   */
  @ViewChild('pickerStart') pickerStart: MatDatepicker<any>;
  @ViewChild('pickerEnd') pickerEnd: MatDatepicker<any>;

  /**
   * Picker labels
   */
  public daterangeLabel = {
    startDate: '',
    endDate: '',
  };
  datePickerForm = this.fb.group({
    startDate: this.fb.control(this.defaultStartDate, Validators.required),
    endDate: this.fb.control(this.defaultEndDate, Validators.required),
  });

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.updateDaterangeLabels(this.defaultStartDate, this.defaultEndDate);
  }

  public handlePickerClosed(picker: 'startDate' | 'endDate') {
    const { startDate, endDate } = this.datePickerForm.value;
    if (picker === 'startDate') {
      this.minEndDateDate = startDate;
      this.pickerEnd.open();
    } else {
      this.onDateRangeChanged.next({
        startDate,
        endDate,
      });
    }
    this.updateDaterangeLabels(startDate, endDate);
  }

  private updateDaterangeLabels(initialDate: Date, finalDate: Date) {
    this.daterangeLabel = {
      startDate: this.parseDate(initialDate),
      endDate: this.parseDate(finalDate),
    };
  }

  private parseDate(date: Date) {
    return `${date.getDate()} · ${date.getMonth() + 1} · ${date.getFullYear()}`;
  }
}
